import { ChangeDetectionStrategy, Component, ElementRef, OnInit } from '@angular/core';
import { AlertController, IonContent, IonIcon, IonTitle, ModalController } from '@ionic/angular/standalone';
import { StatementsComponent } from '../statements/statements.component';
import * as _ from 'lodash';
import { CommonModule } from '@angular/common';
import { WagerFacade } from '@amwager/wager/data-access';
import { AuthFacade } from '@amwager/authentication/data-access';

@Component({
  selector: 'feature-ion-account-history',
  templateUrl: './account-history.component.html',
  styleUrls: ['./account-history.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonContent,
    IonIcon,
    IonTitle,
    StatementsComponent,
    CommonModule
  ]
})
export class AccountHistoryComponent implements OnInit {

  cardContentHTMList!: HTMLElement[];

  controller = {
    statements: false,
    betSummary: false,
    overview: false
  };

  private showAlertInfoHandler?: HTMLIonAlertElement;

  constructor(
    private modalCtrl: ModalController,
    private readonly alertCtrl: AlertController,
    private elementRef: ElementRef,
    private readonly wagerFacade: WagerFacade,
    private readonly authFacade: AuthFacade,
  ) {
    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
      if (isLogout) {
        this.alertCtrl?.dismiss();
        this.showAlertInfoHandler?.dismiss();
      }
    });
  }

  ngOnInit() {
    this.wagerFacade.getAllEventsNameAndId('AccountHistoryComponent:ngOnInit');
  }

  ngAfterViewInit() {

    // hide card-content
    this.cardContentHTMList = this.elementRef.nativeElement.querySelectorAll(
      '.my-history-section .card-content'
    );
    _.forEach(this.cardContentHTMList, (html: HTMLElement) => {
      html.classList.add('card-hide');
    });
  }

  cancel(): void {
    this.modalCtrl.dismiss();
  }

  close(): void {
    this.modalCtrl.dismiss();
  }

  // async openAccountStatements(): Promise<void> {
  //     const modal = await this.modalCtrl.create({
  //       component: StatementsComponent,
  //     });
  //   modal.present();
  // }

  selectHistory(method: string): void {
    // console.log('method:', method)

    if (method === 'betSummary' || method === 'overview') {
      this.showAlertInfo('The countdown to your next big win starts soon!');
      return;
    }

    const historySection = this.elementRef.nativeElement.querySelector(
      '.my-history-section'
    );
    // console.log('history: historySection:', historySection);

    const showCard = this.elementRef.nativeElement.querySelector(
      '.my-history-section .' + method + '.card-content'
    );
    // console.log('history: showCard:', showCard);
    // console.log('history: showCard:', '.my-history-section .' + method + '.card-content');

    const historyRow = this.elementRef.nativeElement.querySelectorAll(
      '.my-history-section .history-row'
    );
    // console.log('history: historyRow:', historyRow);


    const openChev = this.elementRef.nativeElement.querySelector(
      '.my-history-section .' + method + '.history-row .open-chev'
    );
    const closeChev = this.elementRef.nativeElement.querySelector(
      '.my-history-section .' + method + '.history-row .close-chev'
    );

    // open arrow
    if (closeChev.classList.contains('active-chev')) {
      // console.log('OPEN')
      historySection.classList.add('active');
      closeChev.classList.remove('active-chev');
      openChev.classList.add('active-chev');

      // hide all
      _.forEach(this.cardContentHTMList, (cardContent: HTMLElement) => {
        cardContent.classList.add('card-hide');
      });

      // show showCard
      showCard.classList.remove('card-hide');

      historyRow.forEach((row: HTMLElement) => {
        row.classList.add('card-hide');

        if (row.dataset['name'] === showCard.dataset['name']) {
          row.classList.remove('card-hide');
        }
      });

      (this.controller as any)[method] = true;

    }
    // close arrow
    else {
      // console.log('CLOSE')
      historySection.classList.remove('active');
      closeChev.classList.add('active-chev');
      openChev.classList.remove('active-chev');

      // hide all
      _.forEach(this.cardContentHTMList, (html: HTMLElement) => {
        html.classList.add('card-hide');
      });

      // show all
      historyRow.forEach((row: HTMLElement) => {
        row.classList.remove('card-hide');
      });

      (this.controller as any)[method] = false;
    }
  }

  async showAlertInfo(msg: string): Promise<void> {
    this.showAlertInfoHandler = await this.alertCtrl.create({
      header: 'Info',
      message: msg,
      buttons: [
        {
          text: 'Close',
          handler: () => {
            // comment out for now
            // this.ngZone.run(()=>{
            //   this.modalCtrl.dismiss();
            // });
          }
        }
      ]
    });

    await this.showAlertInfoHandler.present();
  }

}
